import LdfForm from "@features/creation/ldf/components/LdfForm";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { PlusCircle } from "lucide-react";

export const Route = createFileRoute("/_app/creation/ldf/create")({
  loader: requirePermission(PERMISSIONS.CREATION.LDF.CREATE),
  staticData: {
    title: "Nouveau LDF",
    icon: PlusCircle,
    permission: PERMISSIONS.CREATION.LDF.CREATE,
    section: "Creation",
    showInBreadcrumb: true,
  },
  component: CreateLdfPage,
});

function CreateLdfPage() {
  return (
    <div className="max-w-5xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">Nouvelle Liste de Fabrication</h1>
        <p className="text-sm text-base-content/60">Créer un nouveau LDF (Liste de Fabrication)</p>
      </div>
      <LdfForm />
    </div>
  );
}
